module.exports = __webpack_public_path__ + "media/add/wheel-seal-88d67fd2.png";